import appConf from "../app-conf";
const setup = appConf[process.env.REACT_APP_CLIENT];
const environment = process.env.NODE_ENV;
const project = "Account Activation";
const server = null;
const service = null;
const config = {
  details: {
    project,
    server,
    environment,
    service,
  },
  application: {
    activation: {
      api: {
        endpoints: {
          checkstripepayment: {
            headers: {
              "Content-Type": "application/json",
              // 'Authorization': 'Bearer ',
            },
            doc: "/pages",
            //url: "/Westfield-Reporting/report21?",
            url:
              setup.setup.api.tranxactor_service.url[environment] +
              "/westfield-payment/stripe",
            // url:
            //   setup.setup.api.tranxactor_service.url[environment] +
            //   "/tx-payment/stripe",
            method: "GET",
          },
          productall: {
            headers: {
              "Content-Type": "application/json",
              // 'Authorization': 'Bearer ',
            },
            doc: "/pages",
            //url: "/Westfield-Reporting/report21?",
            url:
              setup.setup.api.tranxactor_westfield_bulkorder.url[environment] +
              "/products",
            method: "GET",
          },
          checkpayment: {
            headers: {
              "Content-Type": "application/json",
            },
            doc: "https://tr4ns10.tr4ns.com/registration/activation",
            //url: "/Westfield-Reporting/report21?",
            url:
              setup.setup.api.tranxactor_service.url[environment] +
              "/westfield-payment/stripe",
            method: "GET",
          },
          getorder: {
            headers: {
              // appName: "corp",
              "Content-Type": "application/json",
              // 'Authorization': 'Bearer ',
            },
            doc: "/pages",
            //url: "/Westfield-Reporting/report21?",
            url:
              setup.setup.api.tranxactor_westfield_bulkorder.url[environment] +
              "/orders",
            method: "GET",
          },
          getcontact: {
            headers: {
              appName: "corp",
              "Content-Type": "application/json",
              // 'Authorization': 'Bearer ',
            },
            doc: "/pages",
            //url: "/Westfield-Reporting/report21?",
            url:
              setup.setup.api.tranxactor_westfield_bulkorder.url[environment] +
              "/clients",
            method: "GET",
          },
          sendattachment: {
            headers: {
              // appName: "corp",
              "Content-Type": "multipart/form-data",
              // 'Authorization': 'Bearer ',
            },
            doc: "/pages",
            //url: "/Westfield-Reporting/report21?",
            url:
              setup.setup.api.tranxactor_westfield_corp.url[environment] +
              "/mail/invoice",
            method: "POST",
          },
        },
      },
    },
  },
  routes: {
    label: "Account Profile",
    prefix: "/corporate/order",
  },
};

export default config;
